import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { VULNERABILITY_COLUMN_DEFS } from '../vuln-table.constants';

export const useVulnerabilitiesExportColumnNames = () => {
  const { t: tRisks } = useTranslation('riskManagement', {
    keyPrefix: 'risks',
  });

  const EXPORT_VULNERABILITY_COLUMN_NAMES = useMemo(() => {
    return {
      name: tRisks(`tableHeaders.${VULNERABILITY_COLUMN_DEFS.NAME}`),
      riskCountUnresolved: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.RISKS_OPEN}`,
      ),
      riskCountResolved: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.RISKS_RESOLVED}`,
      ),
      cisaKnownExploit: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.CISA_KEV}`,
      ),
      score: tRisks(`tableHeaders.${VULNERABILITY_COLUMN_DEFS.SCORE}`),
      severity: tRisks(`tableHeaders.${VULNERABILITY_COLUMN_DEFS.SEVERITY}`),
      //   source: tRisks(`tableHeaders.${VULNERABILITY_COLUMN_DEFS.SOURCE}`),
      'cve.primary.cvss.v3.score': tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.CVSSV3}`,
      ),
      firstDetectedTime: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.FIRST_DETECTED_TIME}`,
      ),
      lastDetectedTime: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.LAST_DETECTED_TIME}`,
      ),
      issuePublishTime: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.ISSUE_PUBLISH_TIME}`,
      ),
      issueUpdateTime: tRisks(
        `tableHeaders.${VULNERABILITY_COLUMN_DEFS.ISSUE_UPDATE_TIME}`,
      ),
      cve: tRisks(`tableHeaders.${VULNERABILITY_COLUMN_DEFS.CVE}`),
      description: tRisks('tableHeaders.description'),
      recommendations: tRisks('tableHeaders.recommendations'),
      references: tRisks('tableHeaders.references'),
      cpe: tRisks('tableHeaders.cpe'),
      cwe: tRisks('tableHeaders.cew'),
      cvssV3BaseScore: tRisks('tableHeaders.cvssV3BaseScore'),
      cvssV3TemporalScore: tRisks('tableHeaders.cvssV3TemporalScore'),
      cvssV3Vector: tRisks('tableHeaders.cvssV3Vector'),
    };
  }, [tRisks]);

  return { EXPORT_VULNERABILITY_COLUMN_NAMES };
};
